import { useEphattaQuery } from "../../.."
import { useAdvertTransactionService } from "./useAdvertTransactionService"

export const useAdvertTransactionStatus = (id?: string) => {
    const service = useAdvertTransactionService()
    return useEphattaQuery(["Adverts.Subscription.Transaction.Status", id], () => service.status(id!), { enabled: id !== undefined })
} 